export default "__VITE_ASSET__3c451949__"